<app-side-nav>
  <main class="router-container-scale-{{textSize$ | async}} router-container">

    @if (!hideBackButtonOnSomeRoutes) {
      <button
        class="back-button"
        [attr.aria-label]="'back' | translate"
        color="accent"
        (click)="goBack()">
          <mat-icon svgIcon="Icons_PFEIL" class="icon-back" />
          {{'back' | translate}}
      </button>
    }

    <router-outlet #outlet="outlet" />


    <div class="container-dialog"
      #popoverDialog
      id="popover-first-instruction"
      popover="auto">

      <h2>{{'first_onboarding' | translate}}</h2>
      <p>{{'first_onboarding_text_1' | translate}}</p>
      <p>{{'first_onboarding_text_2' | translate}}</p>
      <p>{{'first_onboarding_text_3' | translate}}</p>

      <button  matButton="filled"
        class="button-rounded-center" color="accent"
        (click)="popoverDialog.hidePopover()">
        {{'lets_go' | translate}}
      </button>
    </div>

  </main>
</app-side-nav>
<div id="toast-container"></div>